import React, { useContext } from 'react';
import { EditCellContext } from 'src/contexts/EditCellContext';

import { GridCellProps } from '@progress/kendo-react-grid';
import { informationIcon } from 'src/utils/icons';

const InvoiceInfoCell: React.ComponentType<GridCellProps> = (props) => {
  const [cellClick] = useContext(EditCellContext);
  const func = cellClick?.('');
  const handleClick = () => {
    if (props.dataItem.hasCompanyAccess) {
      func?.cellClick?.(props.dataItem);
    }
  };
  return (
    <td onClick={handleClick}>
      {props?.dataItem.hasCompanyAccess && (
        <div className="flex justify-center items-center hover:cursor-pointer">
          {informationIcon}
        </div>
      )}
    </td>
  );
};

export default InvoiceInfoCell;
